import Experience from '../../../Experience'
import { TRIGGER_ZONE } from '../celestialConfig'

/**
 * MeteorShower — goldenMoon がトリガーゾーンに入っている間の流星群バースト。
 * 既存の ShootingStars プールを流用し、発動中だけ金色の流星が
 * 短い間隔（0.25〜0.75秒）で流れ続ける。退出で通常（白系・4〜10秒間隔）に戻る。
 * low tier では ShootingStars 自体が無効（poolSize 0）なので自動的に何も起きない。
 *
 * エフェクト共通インターフェース: fadeIn / fadeOut / updatePosition / update / dispose
 */
export default class MeteorShower
{
  constructor(bodyConfig)
  {
    this.experience = new Experience()
    this.burstColor = bodyConfig.haloColor ?? '#ffe08a'
  }

  // ShootingStars は World のコンストラクタで生成済みだが、念のため遅延解決
  getShootingStars()
  {
    return this.experience.world?.shootingStars ?? null
  }

  fadeIn()
  {
    // トリガーゾーン方向（＝デフォルトカメラに映る空）のコーン内に流星を集める
    this.getShootingStars()?.setBurst(true, this.burstColor, TRIGGER_ZONE.direction)
  }

  fadeOut()
  {
    this.getShootingStars()?.setBurst(false)
  }

  // 天体には追従しない（流星は空全体に流れる）
  updatePosition()
  {
  }

  update()
  {
  }

  dispose()
  {
    this.getShootingStars()?.setBurst(false)
  }
}
